package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "fr")
val FrStrings = Strings(
    analyzer = "Analyseur",
    appreciationOverview = "Aperçu de l'appréciation",
    chartLegendInterest = "Intérêts",
    chartLegendPrincipal = "Principal",
    chartXaxisMonths = "Mois",
    chartYaxisPayment = "Paiement",
    code = "fr",
    costOfCredit = "Coût du crédit",
    creditDealAnalyzerDescription = "Entrez les détails de votre prêt pour recevoir une analyse complète de votre offre de crédit. Notre analyseur évalue les indicateurs clés pour vous aider à comprendre le coût réel de votre prêt et à prendre une décision éclairée.",
    detailsGoodRateLongTerm = "Bon taux mais une longue durée entraîne un coût total élevé.",
    detailsHighApr = "TAEG élevé. ",
    detailsHighInterestCost = "Coût total des intérêts élevé.",
    detailsHighRateShortTerm = "Taux élevé mais une courte durée maintient le coût total bas.",
    detailsLowApr = "TAEG bas. ",
    detailsLowInterestCost = "Coût total des intérêts bas.",
    discountsTradeIn = "Remises / Reprise",
    displayName = "Français",
    distribution = "Distribution",
    downPayment = "Acompte",
    effectiveApr = "TAEG",
    headerBalance = "Solde",
    headerDate = "Date",
    headerInterest = "Intérêts",
    headerMonth = "#",
    headerPayment = "Paiement",
    headerPrincipal = "Principal",
    hideDetails = "Masquer les détails",
    interest = "Intérêts",
    invalidData = "Données invalides",
    loanAmountSupportingText = "Le montant total du prêt, y compris tous les coûts supplémentaires.",
    loanDetails = "Détails du prêt",
    paymentSupportingText = "Votre paiement mensuel estimé.",
    paymentComposition = "Composition du paiement",
    percentSymbol = "%",
    principal = "Principal",
    ratingBad = "Mauvaise affaire",
    ratingExcellent = "Excellente affaire",
    ratingFair = "Affaire équitable",
    ratingGood = "Bonne affaire",
    ratingPoor = "Affaire médiocre",
    schedule = "Échéancier",
    showDetails = "Afficher les détails",
    summaryBad = "Très défavorable, évitez si possible.",
    summaryExcellent = "Excellentes conditions financières.",
    summaryFair = "Conditions équitables, envisagez de négocier.",
    summaryGood = "Bonnes conditions, standard pour le marché.",
    summaryPoor = "Mauvaises conditions, coût ou taux élevé.",
    totalPaid = "Total payé",
    lockTaxRate = "Verrouiller le taux d'imposition",
    unlockTaxRate = "Déverrouiller le taux d'imposition",
    currencySymbol = "€",
    currency = "Devise",
    totalCreditAmount = "Montant total du crédit",
    taxAmount = "Montant de la taxe/déduction",
    netAmountDisbursed = "Montant net décaissé",
    years = "Années",
    loanTermTotalMonths = "Durée du prêt (mois)",
    monthlyInstallment = "Mensualité",
    principalInstallment = "Remboursement du principal",
    otherFees = "Autres frais",
    insuranceCost = "Prime d'assurance",
    aprc = "Taux Annuel Effectif Global (TAEG)",
    totalAmountPayable = "Montant total dû",
    prepaidFeeFixed = "Frais de dossier (montant fixe)",
    prepaidFeePercentage = "Frais de dossier (pourcentage)",
    months = "Mois",
    description = "Cet analyseur vous aide à évaluer si une offre de prêt vous est favorable. Contrairement aux calculateurs standard, il ne nécessite pas de saisir un taux d'intérêt. Au lieu de cela, il calcule le TAEG et le coût total du crédit en fonction des paiements et des frais, fournissant une évaluation de l'offre et des graphiques détaillés.",
    agree = "Accepter",
    information = "Information",
    errorCalculationOverflow = "Le TAEG est trop élevé, débordement de calcul.",
    errorTotalPaymentIsLessThanLoanAmount = "Le montant reçu est inférieur au montant du prêt.",
    errorDivisionByZero = "Division par zéro",
    errorNegativeResult = "Résultat négatif",
    errorRateTooHigh = "Le taux est trop élevé",
    errorCalculation = "Veuillez saisir des données correctes",
    close = "Fermer",

    hi = "Salut",
    guest = "Invité",
    account = "Compte",
    signInWithGoogle = "Se connecter avec Google",
    signOut = "Se déconnecter",
    settings = "Paramètres",
    about = "À propos",
    privacyPolicy = "Politique de confidentialité",
    termsOfService = "Conditions d'utilisation",
    language = "Langue",

    theme = "Thème",
    light = "Clair",
    dark = "Sombre",
    system = "Système",
    toggleExpand = "Développer/Réduire",
)
